/* expandable_this.js */

function expandable_tree(id, val, init) {

  this.id   = id;
  this.val  = val;
  this.init = init || function() {
    this.$tree              = "div#" + this.id;
    this.$toggleButton      = $("input."+this.id + ".tree-toggle-button");
    this.$branch            = $(this.$tree + " .parent");
    this.$cookie            = $.cookie(this.id)
    this.$state             = this.$cookie ?  $.parseJSON('[' + this.$cookie + ']') : undefined;
    this.has_state          = this.$state != undefined;
    this.has_val            = function() { return $(this.$tree + " input:checked").length; }

    this.store_state();

    //branch functionality
    this.collapse_branches();
    this.branch_click_handler();

    // If there is a stored state it will show that, if not the selected value state, if not branches stay hidden
    if (this.has_state) {
      this.show_state_values();
    } else {
      this.show_selected_values();
    }

    this.show_toggle_button();

    if (this.is_expanded()) {
      this.collapse_tree();
    } else {
      this.expand_tree();
    }

    this.setup_toggle_button();

    this.set_up_li_classes();
  }

  this.show_state_values = function() {
    var tree = this;
    $.each(this.$state, function(index, element) {
        $(tree.$tree).find("#" + element).next().show();
        tree.branch_icon_toggle( $(tree.$tree).find("a#" + element) );
    });
    return false;
  }

  this.show_selected_values = function() {
    var tree = this;
    $(this.$tree + " input:checked").each(function(index, element) {
      $(this)
        .parents("ul.child-level-tree")
        .each(function() {
            $(this).show();
            tree.branch_icon_toggle( $(this).prev() );
        });
    });
  }

  this.branch_toggle = function($element) {
    $element.next().slideToggle('slow');
    this.branch_icon_toggle($element);
    if ( this.is_expanded() ) {
      if( this.has_val() ) {
        this.update_button("Collapse all but selected");
      } else{
        this.update_button("Collapse all items");
      }
    }
    else {
      this.update_button("Show all items");
      this.hide_all_errors();
    }
  }

  this.expand_branch_icon = function($element) {
    $element
      .removeClass("branch-collapsed")
      .addClass("branch-expanded")
      .attr({
        "title" : "Click to collapse",
      });
  }

  this.collapse_branch_icon = function($element) {
    $element
      .removeClass("branch-expanded")
      .addClass("branch-collapsed")
      .attr({
        "title" : "Click to expand",
      });
  }

  this.expand_all_branch_icons = function() {
    var tree = this;
    this.$branch.each(function() {
      tree.expand_branch_icon($(this));
    });
  }

  this.collapse_all_branch_icons = function() {
    var tree = this;
    this.$branch.each(function() {
      tree.collapse_branch_icon($(this));
    });
  }

  this.branch_icon_toggle = function($element) {
    if ($element.hasClass("branch-collapsed")) {
      this.expand_branch_icon($element);
    } else {
      this.collapse_branch_icon($element);
    }
  }

  this.expand_branches = function() {
    $(this.$tree + " .child-level-tree").show();
    this.expand_all_branch_icons();
  }

  this.collapse_branches = function() {
    $(this.$tree + " .child-level-tree").hide();
    this.collapse_all_branch_icons();
  }

  // When you click the button it should show all branches, hide the button and change the icons

  this.show_toggle_button = function() {
    this.$toggleButton.show();
  }

  this.update_button = function($button_text) {
    this.$toggleButton.attr("value", $button_text);
  }

  this.is_expanded = function() {
    return ( $(this.$tree + " .parent").length == $(this.$tree + " .branch-expanded").length );
  }

  this.collapse_tree = function() {
    this.collapse_branches();
    this.hide_all_errors();
    this.show_selected_values();
    this.update_button("Show all items");
  }

  this.expand_tree = function() {
    this.expand_branches();
    this.hide_all_errors();
    if( this.has_val() ) {
      this.update_button("Collapse all but selected");
    } else{
      this.update_button("Collapse all items");
    }
    return false;
  }

  this.setup_toggle_button = function() {
    var tree = this;
    tree.$toggleButton.on('click', function() {
      if (tree.is_expanded()) {
        tree.collapse_tree();
      } else {
        tree.expand_tree();
      }
    });
  }

  this.set_up_li_classes = function() {
    $(".toggle-label").parent().addClass("toggle-label-li");
    $(".item-label").parent().addClass("item-li");
  }

  // toggles the error message - "you can't close a branch with a selection in it"
  this.show_error = function($element) {
    var error_msg = $(this.$tree).find("#" + $element).children(".tree_error");
    $(error_msg)
      .css("display", "inline")
      .fadeOut(5000, function () {
        $(error_msg).css("display", "none")
      });
  }

  this.hide_all_errors = function() {
    $(this.$tree).find(".tree_error").css("display", "none");
  }

  // When you click a branch the icon should alt, the button re-appear, and the branches toggle
  this.branch_click_handler = function() {
    var tree = this;
    this.$branch.on('click', function() {
      if ($(this).next().find('input:checked').length) {
        tree.show_error($(this).attr("id"));
      } else {
        tree.branch_toggle($(this));
      }
    return false;
    });
  }

  //stores the state as a unique cookie file for each tree when you navigate away
  //or close the browser
  this.store_state = function() {
    var tree = this;
    $(window).on("unload", function(event){
      var array = [];
      $(tree.$tree + " .branch-expanded").each(function(){
        array.push(parseInt($(this).attr("id")));
      });
      $.cookie(tree.id, array, { expires: 1 }); //expire in one day
    });
  }
}
